import { useState } from "react";

import CustomSelect from "@components/Forms/FormInputs/CustomSelect";

import { IAssignee, ListTechnologyType } from "@interfaces/portfolio.type";

type InputPropertiesType = {
  organizationId: string;
  organizationUsers?: IAssignee[] | null;
  row: ListTechnologyType;
  setTechnologyAssignees: (data: { organizationId: string; technologyId: string; userIds: string[] }) => void;
};

function AssigneeSelectCellDropdown({
  organizationId,
  organizationUsers,
  row,
  setTechnologyAssignees,
}: InputPropertiesType) {
  // TODO: Update technology in react query so we don't need a local state
  const [selectedAssignees, setSelectedAssignees] = useState<string[]>(
    row.assignees ? row.assignees.map((assignee) => assignee.userAccountId) : [],
  );

  const handleChange = (value: string[]) => {
    setSelectedAssignees(value);

    setTechnologyAssignees({ organizationId, technologyId: row.id, userIds: value });
  };

  if (!organizationUsers) return null;

  return (
    <CustomSelect
      customRenderValue={(selected) => {
        return selected
          .map((userAccountId) => {
            const assignee = organizationUsers?.find((user) => user.userAccountId === userAccountId);
            return assignee ? `${assignee.firstName} ${assignee.lastName}` : null;
          })
          .filter(Boolean) // only keep non-null entries
          .join(", ");
      }}
      defaultSelectedOptions={[]}
      formControlSx={{
        alignContent: "center",
        m: 1,
        width: 300,
      }}
      getOptionLabel={(user) => `${user.firstName} ${user.lastName}`}
      getOptionValue={(user) => user.userAccountId}
      isMultiSelect={true}
      onChange={handleChange}
      options={organizationUsers}
      selectedValues={selectedAssignees}
    />
  );
}

export default AssigneeSelectCellDropdown;
